import nodeApi from '../utils/nodeApiClient';

const reminderSettingsApi = {
  get: () => nodeApi.get('/reminder-settings'),
  update: (data) => nodeApi.put('/reminder-settings', data)
};

export default reminderSettingsApi;
